/* Shared query handling for predictive search and Shopify's full search page. */
window.AtomSearchQuery = (() => {
  const specPattern = /\brgbw?\b|\b\d+(?:\.\d+)?x\d+(?:\.\d+)?mm\b|\b\d+leds\/m\b|\bip\d{2}\b|\b\d+(?:\.\d+)?(?:v|k|w|mm|cm)\b/g;
  const isSku = value => /^[a-z][a-z0-9]*[-_][a-z0-9_-]+$/i.test(value.trim()) && /\d/.test(value);

  function normalize(value) {
    let text = String(value || '').toLowerCase();
    if (isSku(text)) return text.trim();
    return text.replace(/[×✕]/g, 'x')
      .replace(/\b(rgbw?)(?=\d)/g, '$1 ')
      .replace(/(\d(?:mm)?)(?=rgbw?\b)/g, '$1 ')
      .replace(/(\d\s*(?:mm|cm|v|k|w))(?=\d|ip\s*\d)/g, '$1 ')
      .replace(/(ip\d{2})(?=\d)/g, '$1 ')
      .replace(/(\d+(?:\.\d+)?)\s*(?:mm)?\s*x\s*(\d+(?:\.\d+)?)(?:\s*mm)?\b/g, '$1x$2mm')
      .replace(/\bip\s*(\d{2})\b/g, 'ip$1')
      .replace(/(\d+(?:\.\d+)?)\s*(volts?|vdc|v|kelvin|k|watts?|w|mm|cm)\b/g, (_, n, unit) =>
        n + ({ volt: 'v', volts: 'v', vdc: 'v', kelvin: 'k', watt: 'w', watts: 'w' }[unit] || unit))
      .replace(/(\d+)\s*leds?\s*(?:\/\s*m(?:et(?:re|er))?|per\s*met(?:re|er))\b/g, '$1leds/m')
      .replace(/\b(warm|cool|natural|neutral)white\b/g, '$1 white')
      .replace(/\s+/g, ' ').trim();
  }

  function normalizeQuery(value) {
    return normalize(value).replace(/\b(\d+)\s*leds?\b(?!\/m)/g, '$1leds/m')
      .replace(/(\d+)leds\/m/g, '$1 LEDs/m');
  }

  function specifications(value) {
    return [...new Set(normalize(value).match(specPattern) || [])];
  }

  function compile(value) {
    const raw = String(value || '').trim();
    // Respect deliberate advanced queries and exact variant SKU searches.
    if (isSku(raw) || /[\w.]+:|["()]|\b(?:AND|OR|NOT)\b/.test(raw)) return raw;
    return normalize(normalizeQuery(raw)).replace(specPattern, spec => {
      if (spec.endsWith('leds/m')) {
        const density = spec.slice(0, -6);
        return '(' + [`${density} LEDs/m`, `${density}LEDs/m`, `${density} LED/m`, `${density}LED/m`]
          .map(term => `title:"${term}"`).join(' OR ') + ')';
      }
      return `title:"${spec}"`;
    });
  }

  function display(value) {
    return String(value || '')
      .replace(/\(title:"(\d+) LEDs\/m" OR title:"\d+LEDs\/m" OR title:"\d+ LED\/m" OR title:"\d+LED\/m"\)/g, '$1 LEDs/m')
      .replace(/title:"([^"\n]+)"/g, '$1');
  }

  return { normalize, normalizeQuery, specifications, compile, display };
})();
